import { render, staticRenderFns } from "./PowerStandard.vue?vue&type=template&id=086bc48f&scoped=true"
import script from "./PowerStandard.vue?vue&type=script&lang=js"
export * from "./PowerStandard.vue?vue&type=script&lang=js"
import style0 from "./PowerStandard.vue?vue&type=style&index=0&id=086bc48f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086bc48f",
  null
  
)

export default component.exports